var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1179 2.64896C18.8896 1.65706 18.0783 0.925257 17.1016 0.816094C14.7887 0.557914 12.4478 0.556566 10.1176 0.557914C7.78707 0.556566 5.44574 0.557914 3.1329 0.816094C2.15678 0.925257 1.34605 1.65706 1.11771 2.64896C0.792721 4.06154 0.789062 5.60349 0.789062 7.05785C0.789062 8.51221 0.789062 10.054 1.11405 11.4664C1.342 12.4581 2.15293 13.1899 3.12963 13.2992C5.44227 13.5576 7.78341 13.5589 10.114 13.5576C12.4449 13.5589 14.7855 13.5576 17.0979 13.2992C18.074 13.1901 18.8855 12.4583 19.1139 11.4664C19.4391 10.0538 19.4402 8.51201 19.4402 7.05785C19.4402 5.60349 19.4429 4.06154 19.1179 2.64896ZM7.70775 9.9527C7.70775 7.88957 7.70775 5.848 7.70775 3.78468C9.68443 4.81605 11.648 5.8405 13.6372 6.87822C11.6542 7.90671 9.68963 8.92499 7.70775 9.9527Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8f626d5e.svg";
export { ForwardRef as ReactComponent };